import { render, staticRenderFns } from "./commissionSet.vue?vue&type=template&id=67a895aa&scoped=true&"
import script from "./commissionSet.vue?vue&type=script&lang=js&"
export * from "./commissionSet.vue?vue&type=script&lang=js&"
import style0 from "./commissionSet.vue?vue&type=style&index=0&id=67a895aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a895aa",
  null
  
)

export default component.exports